import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { TBrandSourceList, TBrandSourceListResponse, TBrandSourceQuery, adaptBrandListSourceQueryToRequest, adaptBrandSourceFromListResponse } from '../../types';
import { BACKEND_SOURCE_BRAND } from '../../backend-paths';


export const sourceBrandGetApi = createAsyncThunk(
	BACKEND_SOURCE_BRAND,
	(payload: TBrandSourceQuery | undefined, thunkApi) => {
		const params = adaptBrandListSourceQueryToRequest(payload);

		return HttpService.get<TBrandSourceListResponse>(BACKEND_SOURCE_BRAND, { params }).then(result => {
			return adaptBrandSourceFromListResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list: TBrandSourceList;
	query: TBrandSourceQuery;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: {
		items: [],
		count: 0,
	},
	query: {
		limit: 50,
		offset: 0,
		search: undefined,
	},
	error: undefined,
};

export const sourceBrandSlice = createSlice({
	name: 'sourceBrandSlice',
	initialState,
	reducers: {
		setSourceBrandQuerySearch(state, action: PayloadAction<string>) {
			const search = action.payload || undefined;
			const isSearch = search && search.length > 0;

			if (isSearch && state.query.offset !== 0) {
				state.query.offset = 0;
				return;
			}

			state.query.search = search;
		},

		clearSourceBrand(state) {
			return { ...initialState, list: state.list, query: state.query };
		},
	},

	extraReducers: {
		[sourceBrandGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[sourceBrandGetApi.fulfilled.type]: (state, action: PayloadAction<TBrandSourceList>) => {
			state.isLoading = false;
			state.list = action.payload;
			state.error = undefined;
		},

		[sourceBrandGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useSourceBrandSelector = () => useAppSelector(state => state[sourceBrandSlice.name]);

export const { clearSourceBrand, setSourceBrandQuerySearch } = sourceBrandSlice.actions;
